import * as React from 'react';
import type { SVGProps } from 'react';

const SvgSearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m17.296 17.298 5.78 5.779M10.074 19.224a9.15 9.15 0 1 0 0-18.3 9.15 9.15 0 1 0 0 18.3Z"
    />
  </svg>
);
export default SvgSearchIcon;
